import React, { useContext, useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ILPDepthDistribution } from '../../api/interfaces'

import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { colors } from '../../const'
import { useChartData } from '../../hooks/useChartData'

export async function getLPDepthDistributionConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_lp_depth_distribution', timeframe)) as ILPDepthDistribution[]
	const btcData = chartData.filter((row) => row.POOL_NAME === 'BTC.BTC')
	const ethData = chartData.filter((row) => row.POOL_NAME === 'ETH.ETH')
	const baseData = chartData.filter((row) => row.POOL_NAME === 'BASE.ETH')
	const stablecoinData = chartData.filter((row) => row.POOL_NAME === 'STABLECOIN')
	const bnbData = chartData.filter((row) => row.POOL_NAME === 'BSC.BNB')
	const bchData = chartData.filter((row) => row.POOL_NAME === 'BCH.BCH')
	const avaxData = chartData.filter((row) => row.POOL_NAME === 'AVAX.AVAX')
	const dogeData = chartData.filter((row) => row.POOL_NAME === 'DOGE.DOGE')
	const ltcData = chartData.filter((row) => row.POOL_NAME === 'LTC.LTC')
	const othersData = chartData.filter((row) => row.POOL_NAME === 'Others')
	const xrpData = chartData.filter((row) => row.POOL_NAME === 'XRP.XRP')
	const tronData = chartData.filter((row) => row.POOL_NAME === 'TRON.TRX')
	const zecData = chartData.filter((row) => row.POOL_NAME === 'ZEC.ZEC')

	const series1 = btcData.map((element: ILPDepthDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_POOL_DEPTH_USD }
	})
	const series2 = ethData.map((element: ILPDepthDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_POOL_DEPTH_USD }
	})
	const series3 = baseData.map((element: ILPDepthDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_POOL_DEPTH_USD }
	})
	const series4 = stablecoinData.map((element: ILPDepthDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_POOL_DEPTH_USD }
	})
	const series5 = bnbData.map((element: ILPDepthDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_POOL_DEPTH_USD }
	})
	const series6 = bchData.map((element: ILPDepthDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_POOL_DEPTH_USD }
	})
	const series7 = avaxData.map((element: ILPDepthDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_POOL_DEPTH_USD }
	})
	const series8 = dogeData.map((element: ILPDepthDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_POOL_DEPTH_USD }
	})
	const series9 = ltcData.map((element: ILPDepthDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_POOL_DEPTH_USD }
	})
	const series10 = othersData.map((element: ILPDepthDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_POOL_DEPTH_USD }
	})
	const series12 = xrpData.map((element: ILPDepthDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_POOL_DEPTH_USD }
	})
	const series13 = tronData.map((element: ILPDepthDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_POOL_DEPTH_USD }
	})
	const series14 = zecData.map((element: ILPDepthDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_POOL_DEPTH_USD }
	})
	const series11: { x: number; y: number }[] = []

	const maxLen = Math.max(
		series1.length,
		series2.length,
		series3.length,
		series4.length,
		series5.length,
		series6.length,
		series7.length,
		series8.length,
		series9.length,
		series10.length,
		series12.length,
		series13.length,
		series14.length
	)

	for (let i = 0; i < maxLen; i++) {
		const x = series1[i]?.x ?? series2[i]?.x ?? series3[i]?.x ?? 0
		const y =
			(series1[i]?.y ?? 0) +
			(series2[i]?.y ?? 0) +
			(series3[i]?.y ?? 0) +
			(series4[i]?.y ?? 0) +
			(series5[i]?.y ?? 0) +
			(series6[i]?.y ?? 0) +
			(series7[i]?.y ?? 0) +
			(series8[i]?.y ?? 0) +
			(series9[i]?.y ?? 0) +
			(series10[i]?.y ?? 0) +
			(series12[i]?.y ?? 0) +
			(series13[i]?.y ?? 0) +
			(series14[i]?.y ?? 0)

		series11.push({ x, y })
	}
	const config: IChart[] = [
		{
			data: series11,
			strokeWidth: 2,
			name: 'Total',
			type: 'line',
			seriesGroup: '[usd]',
			color: inverseColor,
			unitSymbol: '$'
		},
		{
			data: series1,
			strokeWidth: 2,
			name: 'BTC',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[0]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'ETH',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[2]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		},
		{
			data: series4,
			strokeWidth: 2,
			name: 'STABLECOINS',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[1]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		},
		{
			data: series5,
			strokeWidth: 2,
			name: 'BNB',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[3]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		},
		{
			data: series6,
			strokeWidth: 2,
			name: 'BCH',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[4]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		},
		{
			data: series7,
			strokeWidth: 2,
			name: 'AVAX',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[5]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		},
		{
			data: series8,
			strokeWidth: 2,
			name: 'DOGE',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[6]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		},
		{
			data: series9,
			strokeWidth: 2,
			name: 'LTC',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[7]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		},
		{
			data: series12,
			strokeWidth: 2,
			name: 'XRP',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[8]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'BASE.ETH',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[9]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		},
		{
			data: series13,
			strokeWidth: 2,
			name: 'TRX',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[11]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		},
		{
			data: series14,
			strokeWidth: 2,
			name: 'ZEC',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[13]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		},
		{
			data: series10,
			strokeWidth: 2,
			name: 'Others',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[10]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		}
	]
	const lastPoint = series11.length > 0 ? series11[series11.length - 1] : undefined
	return { config: config, latestValue: lastPoint?.y ?? 0, latestValueDate: lastPoint?.x ?? 0 }
}

const LPDepthDistribution = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getLPDepthDistributionConfig, '1m')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}

	return (
		<ChartPage
			chartTitle="Liquidity Distribution"
			chartDesc={`Total liquidity depth across all pools, broken down by major assets.\n*BNB includes both BSC.BNB and BNB.BNB.\n*Stablecoins consists of all available stablecoin pools on THORChain.`}
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="9ed2d12f-05bf-4f29-9547-a121bc117b38"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			sortByValueDesc={true}
		/>
	)
}

export default LPDepthDistribution
